// C-Core (PostgreSQL + native RLS) client. Auth is carried entirely by HttpOnly cookies:
// the backend exchanges the legacy access cookie for a C-Core base cookie, and issues a
// session cookie (user + active membership) on select-org. No tokens are ever exposed to JS.
import axios from "axios";

const CCORE = `${process.env.REACT_APP_BACKEND_URL}/api/ccore`;
const DEFAULT_PREFIX = "nyk_ccore_default_";

// Default org is a convenience hint only (membership id); the server re-validates membership every request.
export const ccoreDefault = {
  get: (uid) => (uid ? localStorage.getItem(DEFAULT_PREFIX + uid) : null),
  set: (uid, mid) => { if (uid && mid) localStorage.setItem(DEFAULT_PREFIX + uid, mid); },
};

const http = axios.create({ baseURL: CCORE, withCredentials: true });

export const ccoreApi = {
  exchange: () => http.post("/auth/exchange").then((r) => r.data),
  memberships: () => http.get("/me/memberships").then((r) => r.data.memberships),
  selectOrg: (membershipId) => http.post("/session/select-org", { membershipId }).then((r) => r.data),
  context: () => http.get("/session/context").then((r) => r.data),
  createOrg: (body) => http.post("/orgs", body).then((r) => r.data),
  members: () => http.get("/orgs/current/members").then((r) => r.data.members),
  orgRoles: () => http.get("/orgs/current/roles").then((r) => r.data.roles),
  orgInvites: () => http.get("/orgs/current/invitations").then((r) => r.data.invitations),
  createInvite: (body) => http.post("/orgs/current/invitations", body).then((r) => r.data),
  revokeInvite: (id) => http.post(`/orgs/current/invitations/${id}/revoke`, {}).then((r) => r.data),
  resendInvite: (id) => http.post(`/orgs/current/invitations/${id}/resend`, {}).then((r) => r.data),
  myInvites: () => http.get("/me/invitations").then((r) => r.data.invitations),
  previewInvite: (token) => http.get("/invitations/preview", { params: { token } }).then((r) => r.data),
  acceptInvite: (body) => http.post("/invitations/accept", body).then((r) => r.data),
  rejectInvite: (body) => http.post("/invitations/reject", body).then((r) => r.data),
};
